import { render, staticRenderFns } from "./flow_node.vue?vue&type=template&id=c8245d16&scoped=true&"
import script from "./flow_node.vue?vue&type=script&lang=js&"
export * from "./flow_node.vue?vue&type=script&lang=js&"
import style0 from "./flow_node.vue?vue&type=style&index=0&id=c8245d16&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8245d16",
  null
  
)

export default component.exports